export const FREE_VENUE_FEATURES = [
    'Public venue profile and contact details',
    'Members and permissions management',
    'Stand, peg, and lane setup',
    'Connect Perks management',
    'Public venue profile preview'
];

export const PREMIUM_VENUE_FEATURES = [
    'Maps & photos',
    'Events publishing and management',
    'Till / POS',
    'Communications',
    'Marketplace / shopfront',
    'Premium branding and richer public visibility'
];

export const VENUE_PLAN_ROWS = [
    {
        feature: 'Public venue profile',
        free: 'Included',
        premium: 'Included with richer branding and stronger presentation'
    },
    {
        feature: 'Branding and public visibility',
        free: 'Standard venue profile styling',
        premium: 'Premium branding, richer public visibility, and stronger venue presentation'
    },
    {
        feature: 'Members and stands management',
        free: 'Included',
        premium: 'Included'
    },
    {
        feature: 'Connect Perks',
        free: 'Included with venue-side management',
        premium: 'Included with stronger public visibility'
    },
    {
        feature: 'Public profile preview links',
        free: 'Included',
        premium: 'Included with storefront and shopfront journey'
    },
    {
        feature: 'Maps & photos',
        free: 'Not included',
        premium: 'Included'
    },
    {
        feature: 'Events',
        free: 'Not included',
        premium: 'Included'
    },
    {
        feature: 'Till / POS',
        free: 'Not included',
        premium: 'Included'
    },
    {
        feature: 'Communications',
        free: 'Not included',
        premium: 'Included'
    },
    {
        feature: 'Marketplace / shopfront',
        free: 'Light public profile only',
        premium: 'Dedicated shopfront management and stronger public merchandising'
    },
    {
        feature: 'Upgrade process',
        free: 'Contact Shoot Connect to upgrade and be invoiced manually',
        premium: 'Managed directly with Shoot Connect'
    }
];

export const PREMIUM_MANAGEMENT_AREAS = [
    'Maps & Photos',
    'Events',
    'Till / POS',
    'Communications',
    'Marketplace / Shopfront'
];

export const isPremiumVenueProfile = (club) => Boolean(
    club?.isPremiumVenue || (club?.profileTier || '').toLowerCase() === 'premium'
);
